import React from 'react'
import "./Hero.scss"
import { motion } from 'framer-motion'
import portfolio from '../../assets/nur.jpg'
const Hero = () => {
    const moveVariants = {
        animation: {
            y: [0, -15],
            transition: {
                yoyo: Infinity,
                duration: 2,
                delay: 1
            }

        }
    }

    const buttonVariants = {
        hover: {
            scale: 1,
            textShadow: "0px 0px 8px rgb(255,255,255)",
            boxShadow: "0px 0px 8px rgb(255,255,255)",
            transition: {
                duration: 0.3,
                yoyo: 5
            }
        }
    }


    return (
        <motion.div
            className='container'
            id='home'
            initial={{ y: -15, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
                duration: 2,
                delay: 0.5
            }}
        >
            <motion.div 
                drag
                dragConstraints={{ left: 0, top: 0, right: 0, bottom: 0 }}
                dragElastic={0.7}
                className="profile"
            >
                <img src={portfolio} alt="portfolio" />
            </motion.div>
            <div className="profile_text">
                <h3 className='name'>Hi, I'm <span>Md. Ashanaur Rahman</span></h3>
                <span className='job'>Full Stack Web Developer</span>
                <span className='text'>"Create digital experiences that delight and exceed expectations."</span>
                <motion.a
                    href="#contact"
                    variants={buttonVariants}
                    whileHover="hover"
                >
                    HIRE ME
                </motion.a>
                <motion.div
                    initial={{ y: '-10rem' }}
                    whileInView={{ y: 0 }}
                    transition={{ type: 'spring', stiffness: 120, duration: 3 }}
                    className='web'
                >
                    NODE JS
                </motion.div>
                <motion.div
                    initial={{ y: '-10rem' }}
                    whileInView={{ y: 0 }}
                    transition={{ type: 'spring', stiffness: 120, duration: 3 }}
                    className='ui'
                >
                    REACT JS
                </motion.div>
                {/* <div
                    className="freelance"
                >
                    Freelancer
                </div> */}
            </div>
        </motion.div>
    )
}

export default Hero